import React from 'react';
import { Box, Typography, Card, CardContent, CardActionArea, Grid, SvgIcon } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ChatIcon from '@mui/icons-material/Chat';
import MicIcon from '@mui/icons-material/Mic';
import DescriptionIcon from '@mui/icons-material/Description';
import PageHeader from '../../../components/compliance/layout/PageHeader';

const ReportsPage = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
      <PageHeader 
        title="Compliance Hub" 
        subtitle="Access your compliance tools and AI assistants." 
      />
      
      <Grid container spacing={3} sx={{ mt: 2 }}>
        {/* Compliance Text Chat */}
        <Grid item xs={12} md={4}>
          <Card variant="outlined" sx={{ height: '100%', borderRadius: 2 }}>
            <CardActionArea 
              onClick={() => navigate('/compliance/dashboard')}
              sx={{ height: '100%', p: 2 }}
            >
              <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                <ChatIcon color="primary" sx={{ fontSize: 60, mb: 2 }} />
                <Typography variant="h6" fontWeight={700} gutterBottom>
                  AI Compliance Librarian
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Ask compliance questions via chat and get instant answers sourced directly from your verified regulatory documents.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* AI Voice Assistant */}
        <Grid item xs={12} md={4}>
          <Card variant="outlined" sx={{ height: '100%', borderRadius: 2 }}>
            <CardActionArea 
              onClick={() => navigate('/voice-chat')}
              sx={{ height: '100%', p: 2 }}
            >
              <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                <MicIcon color="secondary" sx={{ fontSize: 60, mb: 2 }} />
                <Typography variant="h6" fontWeight={700} gutterBottom>
                  AI Voice Assistant
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Talk directly to our AI to check compliance requirements hands-free, integrated with your live document database.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Future Reports / Document Store */}
        <Grid item xs={12} md={4}>
          <Card variant="outlined" sx={{ height: '100%', borderRadius: 2 }}>
            <CardActionArea 
              onClick={() => {}}
              sx={{ height: '100%', p: 2 }}
            >
              <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                <DescriptionIcon color="action" sx={{ fontSize: 60, mb: 2 }} />
                <Typography variant="h6" fontWeight={700} gutterBottom>
                  Formal Reports
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Generate comprehensive compliance reports and regulatory audits. (Coming soon)
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReportsPage;
